export default __webpack_public_path__ + "static/media/case-XC60.a16295b0.jpg";